import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'
const constApi = {
  // 价格 - 旧接口（保留PriceConfig组件使用）
  price_list: baseAPI + baseUrl + 'goods/price_config_list',
  add_price: baseAPI + baseUrl + 'goods/update_price_config',
  delete_price: baseAPI + baseUrl + 'goods/delete_price_config',
  
  // 增强价格列表 - 新接口
  enhanced_price_list: baseAPI + baseUrl + 'goods/enhanced_price_list',
  batch_update_price: baseAPI + baseUrl + 'goods/batch_update_price',
  
  // 货币国家关联管理
  currency_mapping_list: baseAPI + baseUrl + 'currency_country_mapping/list',
  currency_mapping_create: baseAPI + baseUrl + 'currency_country_mapping/create',
  currency_mapping_update: baseAPI + baseUrl + 'currency_country_mapping/update',
  currency_mapping_delete: baseAPI + baseUrl + 'currency_country_mapping/delete',
  
  // 国家列表
  country_list: baseAPI + baseUrl + 'goods/country_list_v2',
  
  // 国家管理 - 旧接口（保留）
  create_country: baseAPI + baseUrl + 'goods/create_country',
  del_country: baseAPI + baseUrl + 'goods/delete_country',
}

// ==================== 增强价格列表相关接口 ====================

// 获取增强价格列表
export const getEnhancedPriceList = async (params = {}) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.enhanced_price_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: params
  })
  return res
}

// 批量更新价格
export const batchUpdatePrice = async (priceList) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.batch_update_price,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      priceList
    }
  })
  return res
}

// ==================== 货币国家关联管理接口 ====================

// 获取货币国家关联列表
export const getCurrencyMappingList = async (params = {}) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.currency_mapping_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: params
  })
  return res
}

// 创建货币国家关联
export const createCurrencyMapping = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.currency_mapping_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 更新货币国家关联
export const updateCurrencyMapping = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.currency_mapping_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 删除货币国家关联
export const deleteCurrencyMapping = async (id = null) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.currency_mapping_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      id
    },
  })
  return res
}

// 获取可用国家列表（用于多选）
export const getAvailableCountryList = async (type,excludeRecordId = null) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.country_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      type,
      excludeRecordId,
      includeDetails:false
    }
  })
  return res
}

// ==================== 旧接口（保留PriceConfig组件使用） ====================

// 价格
export const getPriceList = async () => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.price_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    }
  })
  return res
}

// 价格
export const addPriceList = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.add_price,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 价格
export const delPriceList = async (id) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.delete_price,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data: {
      data: {
        id
      }
    }
  })
  return res
}

export const addCountry = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.create_country,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

// 国家列表
export const getCountryList = async () => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.country_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    }
  })
  return res
}

export const delCountry = async (countryCode) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.del_country,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data: {
      countryCode
    }
  })
  return res
}

